import _ from 'lodash';

/**
 * Recognises the error messages produced when a request was deliberately aborted. Matches the message against the browser's 'The user aborted a request' and 'The operation was aborted' wordings plus axios's 'canceled'.
 *
 * @param msg - Error message to inspect; an undefined message never matches.
 * @returns True when the message describes a cancelled request rather than a real failure.
 */
const isCanceledApiMessage = (msg: string | undefined): boolean =>
  _.includes(msg, 'The user aborted a request') ||
  _.includes(msg, 'The operation was aborted') ||
  _.includes(msg, 'canceled');

export default isCanceledApiMessage;
